/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemCameraSubjectResponseFromJSON(json) {
    return WallItemCameraSubjectResponseFromJSONTyped(json, false);
}
export function WallItemCameraSubjectResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'inResponseToWallItemId': !exists(json, 'in_response_to_wall_item_id') ? undefined : json['in_response_to_wall_item_id'],
        'accepted': !exists(json, 'accepted') ? undefined : json['accepted'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}
export function WallItemCameraSubjectResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'in_response_to_wall_item_id': value.inResponseToWallItemId,
        'accepted': value.accepted,
        'status': value.status,
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemCameraSubjectResponseStatus;
(function (WallItemCameraSubjectResponseStatus) {
    WallItemCameraSubjectResponseStatus["ABORTED"] = "CAMERA_SUBJECT_RESPONSE_STATUS_ABORTED";
    WallItemCameraSubjectResponseStatus["ACCEPTED"] = "CAMERA_SUBJECT_RESPONSE_STATUS_ACCEPTED";
    WallItemCameraSubjectResponseStatus["REJECTED"] = "CAMERA_SUBJECT_RESPONSE_STATUS_REJECTED";
})(WallItemCameraSubjectResponseStatus || (WallItemCameraSubjectResponseStatus = {}));
//# sourceMappingURL=WallItemCameraSubjectResponse.js.map